import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import _ from 'lodash';
import { getOrganisations } from 'app/ducks/organisations/selectors';
import { getAdmins } from 'app/ducks/admins/selectors';
import { getCompetitions } from 'app/ducks/competitions/selectors';
import { getAuthentication } from 'app/ducks/authentication/selectors';
import { getStripeSessions } from 'app/ducks/stripeSessions/selectors';
import * as authenticationActions from 'app/ducks/authentication/actions';
import * as stripeSessionActions from 'app/ducks/stripeSessions/actions';

import NavBar from './components/NavBar';
import TopBar from './components/TopBar';

export function selector(state) {
  return {
    admins: getAdmins(state),
    organisations: getOrganisations(state),
    competitions: getCompetitions(state),
    authentication: getAuthentication(state),
    stripeSessions: getStripeSessions(state),
  };
}

interface ISideBarProps {
  actions: any;
  authentication: any;
  admins: any;
  organisations: any;
  competitions: any;
  stripeSessions: any;
  match: any;
}

const actionCreators = _.merge(authenticationActions, stripeSessionActions);


@connect(
  selector,
  (dispatch) => ({
    actions: bindActionCreators(actionCreators, dispatch),
  } as any),
)
export default class SideBar extends React.Component<ISideBarProps> {
  static defaultProps: ISideBarProps = {
    actions: {},
    admins: {},
    authentication: {},
    organisations: {},
    competitions: {},
    stripeSessions: {},
    match: {},
  };

  shouldComponentUpdate(nextProps): boolean {
    if (
      nextProps.admins.currentAdmin.firstName
        === this.props.admins.currentAdmin.firstName
      && nextProps.admins.currentAdmin.lastName
        === this.props.admins.currentAdmin.lastName
      && nextProps.competitions.currentCompetition.id
        === this.props.competitions.currentCompetition.id
      && nextProps.match.url === this.props.match.url
    ) {
      return false;
    }
    return true;
  }

  handleStripeBilling = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.actions.createStripeSession({});
  }

  render(): React.ReactNode {
    return (
      <div>
        <NavBar
          {...this.props}
          handleStripeBilling={this.handleStripeBilling}
          competitionName={
            this.props.competitions.currentCompetition.name || ''
          }
          competitionid={this.props.competitions.currentCompetition.id || ''}
        />
        <TopBar
          {...this.props}
          handleStripeBilling={this.handleStripeBilling}
          competitionName={
            this.props.competitions.currentCompetition.name || ''
          }
          competitionid={this.props.competitions.currentCompetition.id || ''}
        />
      </div>
    );
  }
}
